import {confirm} from "devextreme/ui/dialog";
import {useContext} from "react";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {AR, FileTypes, OrderStatus} from "../../../../types/enums";
import {showErrorMessage, showSuccessMessage} from "../../../../utils/messages";
import {useSubmitWOC} from "../api/submit-woc";
import {WorkOrderContext} from "../context/WorkOrderContext";
import WorkOrderFiles from "./WorkOrderFiles";

export default function WOCFiles() {
	const { order, refetchOrder } = useContext(WorkOrderContext);

	const navigate = useNavigate();
	const location = useLocation();

	const [searchParams] = useSearchParams();
	const returnUrl = encodeURIComponent(searchParams.get("returnUrl") ?? "");

	const submitWOC = useSubmitWOC(
		order.details.workOrderID,
		(result) => {
			showSuccessMessage('Files have been submitted');
			refetchOrder()
				.then(() => {
					const newActionRequiredID = result.activeARs[0];

					const to = `/cfi/work-order/${order.details.workOrderID}/${newActionRequiredID}` +
						(!!returnUrl ? '?returnUrl=' + returnUrl : '');

					if (newActionRequiredID && location.pathname !== to) {
						navigate(to);
					}
				});
		},
		(error) => showErrorMessage(error)
	);

	return (
		<WorkOrderFiles
			fileTypes={[FileTypes.WOC]}
			buttonCaption={order.details.activeARs.includes(AR.WOCfiToUploadWOC) ? 'Upload WOC' : undefined}
			onFileAdded={(fileType: FileTypes) => {
				if (fileType === FileTypes.WOC && order.details.orderStatusID !== OrderStatus.Pending) {
					confirm("Do you want to submit the file?", "Submit File")
						.then((result) => {
							if (result) {
								submitWOC.mutate();
							}
						});
				}
			}}
		/>
	)
}
